import { render, staticRenderFns } from "./FAQDetail.vue?vue&type=template&id=5efd98de&scoped=true"
import script from "./FAQDetail.vue?vue&type=script&lang=js"
export * from "./FAQDetail.vue?vue&type=script&lang=js"
import style0 from "./FAQDetail.vue?vue&type=style&index=0&id=5efd98de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efd98de",
  null
  
)

export default component.exports